import './App.css';
import Menu from './components/Menu/Menu';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import EDiscovery from './pages/ediscovery';
import FileseDiscovery from './pages/fileseDiscovery';
import FilesContractReview from './pages/filesContractReview';
import Home from './pages/home';
import EntitySearch from './pages/entitysearch';
import KeywordSearch from './pages/keywordsearch';
import QuerySearch from './pages/querysearch';
import Account from './pages/account';
import SavedSearch from './pages/savedsearches';
import EntitySerachReports from './pages/entityserachreports';
import KeywordSerachReports from './pages/keywordserachreports';
import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { API, Auth } from 'aws-amplify'
import React, { useEffect, useState } from 'react'
import SearchType from './pages/searchtype';
import QuerySerachReports from './pages/queryserachreports';
import Summarize from './pages/summarize';
import QuestionAnswering from './pages/question-answering';
import ContentGeneration from './pages/content-generation';
import ContractReview from './pages/contractreview';
import FilesCaseLawSearch from './pages/filesCaseLawSearch';
import CaseLawSearch from './pages/caselawsearch'
import Subscription from './pages/subscription';
import CancelSubscription from './pages/cancel';
import SuccessfulSubscription from './pages/success'

function App({ signOut, user }) {
	//Auth.signOut();
	
	const newUser = async () => {
		const token = user.signInUserSession.idToken.jwtToken
		console.log(user)
		const credentials = await Auth.currentUserCredentials();
		console.log("identityId", credentials.identityId);
		const requestInfo = { headers: { Authorization: token } }
		API.get("DocumentSearchUser", `/newuser?identity_id=${credentials.identityId}`, requestInfo)
		.then(response => {
			console.log(response)
		})
		.catch(error => {
			console.log(error)
		})
	}
	useEffect(() => { newUser() }, [])
	
	const checkUser = async(user) => {
        const token = user.signInUserSession.idToken.jwtToken
        const credentials = await Auth.currentUserCredentials();
		
        const requestInfo = { headers: { Authorization: token } }
        console.log('checkUser')
        API.get("DocumentSearchUser", `/getuserinfo`, requestInfo)
        .then(response => {

        	console.log('response')
            console.log(response)
            // setUserInfo(response)
            localStorage.setItem('query_searches', response.query_searches)
            localStorage.setItem('entity_searches', response.entity_searches)
            localStorage.setItem('keyword_searches', response.keyword_searches)
            localStorage.setItem('user_files', response.user_files)
            localStorage.setItem('user_pages', response.user_pages)
            localStorage.setItem('user_time', response.user_time)
            localStorage.setItem('user_type', response.user_type)
        })
        .then(error => {
            console.log(error)
        })
    }
    useEffect(() => {checkUser(user)}, [])

	return (

		<Router>
			<Menu user={user}/>
			<Routes>
				<Route exact path='/' element={<Home user={user}/>} />
				<Route path="/searchtype" element={<SearchType/>}/>
				{/* <Route exact path='/projects' element={<Projects key={Math.random()}/>} /> */}
				<Route exact path='/ediscovery' element={<EDiscovery />} />
				<Route exact path='/contractreview' element={<ContractReview />} />
				<Route exact path='/caselawsearch' element={<CaseLawSearch />} />
				<Route path='/account' element={<Account user={user} />} />
				<Route path='/filesediscovery' element={<FileseDiscovery />} />
				<Route path='/filescontractreview' element={<FilesContractReview />} />
				<Route path='/filescaselawsearch' element={<FilesCaseLawSearch />} />
				<Route path='/savedsearches' element={<SavedSearch />} />
				<Route path='/keywordsearch' element={<KeywordSearch user={user} />} />
				<Route path='/entitysearch' element={<EntitySearch user={user} />} />
				<Route path='/querysearch' element={<QuerySearch user={user} />} />
				<Route path='/entityserachreports' element={<EntitySerachReports />} />
				<Route path='/keywordserachreports' element={<KeywordSerachReports />} />
				<Route path='/queryserachreports' element={<QuerySerachReports />} />
				<Route path='/summarize' element={<Summarize/>} />
				<Route path='/question-answering' element={<QuestionAnswering/>} />
				<Route path='/content-generation' element={<ContentGeneration/>} />
				<Route path='/subscription' element={<Subscription user={user} />} />
				<Route path='/cancel' element={<CancelSubscription />} />
				<Route path='/success' element={<SuccessfulSubscription user={user} />} />

			</Routes>
		</Router>
	);
}

export default withAuthenticator(App);
//  export default App;